import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import AnalyticsCard from './AnalyticsCard';

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const total = payload.reduce((s, p) => s + (p.value || 0), 0);
  return (
    <div className="bg-background-secondary border border-border-primary rounded-lg shadow-lg p-3 text-xs">
      <p className="font-semibold text-text-primary mb-1">{label}</p>
      {payload.map((p) => (
        <p key={p.name} className="flex gap-2" style={{ color: p.color }}>
          {p.name}: <span className="font-bold">{p.value?.toLocaleString()}</span>
        </p>
      ))}
      <p className="text-text-secondary mt-1 border-t border-border-primary pt-1">
        Total: <span className="font-bold text-text-primary">{total.toLocaleString()}</span>
      </p>
    </div>
  );
}

export default function MakeAnalytics({ data }) {
  return (
    <AnalyticsCard title="Claims by Vehicle Make (Top 12)">
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={data} layout="vertical" margin={{ top: 0, right: 16, left: 4, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#e5e7eb" />
          <XAxis type="number" tick={{ fontSize: 10, fill: '#7e848c' }} />
          <YAxis dataKey="make" type="category" tick={{ fontSize: 10, fill: '#1e2125' }} width={90} />
          <Tooltip content={<ChartTooltip />} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <Bar dataKey="completed" name="Completed" fill="#10b981" stackId="a" radius={[0, 2, 2, 0]} />
          <Bar dataKey="failed"    name="Failed"    fill="#ef4444" stackId="a" radius={[0, 2, 2, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </AnalyticsCard>
  );
}
